/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ActivityType;
(function (ActivityType) {
    ActivityType["GameChampionship"] = "game_championship";
    ActivityType["GameConsolation"] = "game_consolation";
    ActivityType["GameSeason"] = "game_season";
    ActivityType["GameFinal"] = "game_final";
    ActivityType["GameFriendly"] = "game_friendly";
    ActivityType["GameLeague"] = "game_league";
    ActivityType["GamePlayoff"] = "game_playoff";
    ActivityType["GamePoolPlay"] = "game_pool_play";
    ActivityType["GameSemifinal"] = "game_semifinal";
    ActivityType["GameScrimmage"] = "game_scrimmage";
    ActivityType["GameTeamPractice"] = "game_team_practice";
    ActivityType["GameTournament"] = "game_tournament";
    ActivityType["GameTravel"] = "game_travel";
    ActivityType["GameQuarterfinal"] = "game_quarterfinal";
    ActivityType["EventBooking"] = "event_booking";
    ActivityType["EventCamp"] = "event_camp";
    ActivityType["EventClass"] = "event_class";
    ActivityType["EventGame"] = "event_game";
    ActivityType["EventLeague"] = "event_league";
    ActivityType["EventLesson"] = "event_lesson";
    ActivityType["EventMeeting"] = "event_meeting";
    ActivityType["EventOther"] = "event_other";
    ActivityType["EventPractice"] = "event_practice";
    ActivityType["EventScrimmage"] = "event_scrimmage";
    ActivityType["EventTournament"] = "event_tournament";
    ActivityType["EventTraining"] = "event_training";
})(ActivityType || (ActivityType = {}));
